<!-- <div class="container-sign-in">

  <div class="row header-sign-in">
    <div class="login-header">
      <img src="../../assets/img/nagar_nigam_logo.png" alt="logo" class="logo" style="border-radius: 50%;">
      <div class="header-text">
        <h3>Lucknow Nagar Nigam</h3>
        <p style="    padding: 0px;margin: 0px;">लखनऊ नगर निगम</p>
      </div>
    </div>
  </div>
  <div class="row content-sign-in">

    <div class="row heading-container">

    </div>

    <div class="row login-container">

    </div>

  </div>
  <div class="row footer-sign-in" style="background-color: #226CE0;color: white;">
    
    <div class="col-12 footer-col"
      style="display: flex;gap: 70px; justify-content: space-between;align-items: center; padding: 0px 120px;">
      <div>
        <p><strong> Lucknow Nagar Nigam</strong></p>
        <p>लखनऊ नगर निगम</p>
        <p>Trilok Nath Road, Lalbagh <br>
          Lucknow, Uttar Pradesh 226001</p>
      </div>
      <div>
        <p><strong>Contact Information</strong></p>
        <p>Phone: 0522-2622242</p>
        <p>Email: loremnagarnigamlucknow&#64;gmail.com</p>
        <p>Helpline: 1533</p>
      </div>
    </div>
  </div>
</div> -->
<app-spinner></app-spinner>
<div class="container-fluid">
  <div class="login-header">
    <img src="../../assets/img/nagar_nigam_logo.png" alt="logo" class="logo"
      style="border-radius: 50%; height: 50px; width: 50px;">
    <div class="header-text">
      <h3>Lucknow Nagar Nigam</h3>
      <p style="padding: 0px;margin: 0px;">लखनऊ नगर निगम</p>
    </div>
  </div>
  <div class="signin-main-content">
    <div class="login-box-heading">
      <h1 style="margin: 0;padding: 0;" class="my-3">Welcome to Samadhan Diwas Portal</h1>
    </div>
    <div class="login-wrapper">
      <div class="login-box my-3">
  
      <div style="display:flex ; justify-content: center ; align-items: center;  height: -webkit-fill-available;">
        <div>
        <h3 class="login-text">LOGIN</h3>

        <p class="steps">
          <span class="step-block">
            <span [class.active]="step === 1" class="step-number"
              style=" border-radius: 50%; color: white;border: 1px solid;height: 30px;width: 30px;padding:5px;background-color: #007AFF;">1</span>
            <span class="step-label">Enter Login Details</span>
          </span>
          <span class="arrow">-----------------</span>
          <span class="step-block">
            <span [ngClass]="{'active': step === 2}" class="step-number2">2</span>
            <span class="step-label">OTP Verification</span>
          </span>
        </p>


        <!-- Step 1: Login Form -->
        <form *ngIf="step === 1" novalidate autocomplete="off">
          <div >
            <label for="email" class="left-align-label"> <span  >Mobile Number</span>  </label>
          <input class="form-control" type="number" name="mobile_number" (change)="allowLoginValidate()" maxlength="10"   oninput="if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"       placeholder="Enter Mobile Number" autocomplete="off"    [(ngModel)]="mobile_number" appRestirctNumberScroll>
          </div>

         <div  *ngIf="auth.uiHost!='samadhan.upnn.co.in'" >
            <label for="password" class="left-align-label" style="margin-top: 15px;">Password</label>
            <input class="form-control" id="password" type="password" name="password" placeholder="Enter Password"
              autocomplete="off" [(ngModel)]="obj.password" >
 
          </div> 

          <!-- <div>
                    <label for="captcha">Captcha</label>
                    <div class="captcha-row">
                        <i class="fa fa-refresh" (click)="generateCaptcha()" style="cursor: pointer;"></i>
                        <p class="otp-bg-image">{{captcha}}</p>
                        <input id="captcha" type="text" name="captcha" [(ngModel)]="formData.captcha"
                            placeholder="Enter Captcha" required #captchaRef="ngModel" />
                    </div>
                    <div *ngIf="captchaRef.invalid && captchaRef.touched" class="error">
                        <small *ngIf="captchaRef.errors?.['required']">Captcha is required.</small>
                    </div>
                </div> -->
          <div class="input-wrapper mt-2">
            <div class="d-flex align-items-center justify-content-evenly">
              <label class="left-align-label">captcha</label>
              <img [src]="captchaImage" alt="CAPTCHA" class="captcha-image me-2" />
              <div
                style="color:#f1d8bb; text-shadow: 2px 2px 0 #d4a6d1, -2px -2px 0 #d4a6d1, 2px -2px 0 #d4a6d1, -2px 2px 0 #d4a6d1; cursor: pointer;"
                (click)="reloadCaptcha()">
                <h6 class="m-0" style="font-size: 30px;"><i class="fa fa-refresh" aria-hidden="true"></i></h6>
              </div>
            </div>
            <input type="text" [(ngModel)]="inputCaptcha" name="captchaInput" class="form-control mt-2"
              placeholder="Enter captcha" maxlength="6" spellcheck="false" required style="margin:20px 0px;">
          </div>
 
          <button type="submit" class="my-3 w-100 p-2" (click)="checkCaptcha()" style="background-color:#007AFF; color: white;border: none; border-radius: 5px;">Send OTP</button>
          <button *ngIf="auth.uiHost!='samadhan.upnn.co.in'" type="submit" class="my-3 w-100 p-2" (click)="logins()" style="background-color:#007AFF; color: white;border: none; border-radius: 5px;">Login</button>
        </form>

        <!-- OTP Verification Step -->
        <div *ngIf="step === 2" class="otp-box">
          <div class="row">
               <div class="col-12">
              <h6 style="text-align: start;">Registered Mobile Number</h6>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
          <input id="dummynumber" name="dummynumber" type="text" [(ngModel)]="cn" disabled
            style="background-color: #e0e0e0; color: #555; border: 1px solid #ccc; padding: 8px;margin-top: 0px;margin-bottom: 0px; width: 100%; margin-bottom: 10px;">
          <br *ngIf="!otp_flag">
          </div>
         </div>
          <!-- <label for="otpver">Enter OTP</label> -->
          <div class="row mt-2 mb-1" *ngIf="otp_flag">
            <!-- <div class="col-1"></div> -->
            <div class="col-12">
              <h6 style="text-align: start;">Enter OTP</h6>
            </div>
            <!-- <div class="col-1"></div> -->
          </div>
          <div class="row" *ngIf="otp_flag">
            <!-- <div class="col-1"></div> -->
            <div class="col-12"> <input class="form-control" id="otpver" type="password" name="otp_no"
                [placeholder]="auth.allLableShowObj[auth.language_cd + 'LOGIN12'] || 'Enter OTP'" [(ngModel)]="otp_no"
                required /></div>
            <label>{{ resendOTPMessage }}</label>
            <!-- <div class="col-1"></div> -->
          </div>

          <!-- <button type="button" class="resend-link" (click)="loginToAll()">Don't receive the OTP? RESEND</button> -->
          <div class="row mt-1 mb-4">
            <!-- <div class="col-1"></div> -->
            <div class="col-12 p-1 slide d-flex">
              <button [disabled]="resendOTPbutton" *ngIf="otp_flag" class="custom-otp-btn" (click)="loginToAll()"
                type="button" [ngStyle]="{'color': resendOTPbutton ? '#A0C1F7' : '#226CE0'}"
                style="text-align: left; padding-left: 10px;">

                <h5 class="p-0 m-0 text-start">
                  Don't receive the OTP? {{auth.allLableShowObj[auth.language_cd+'LOGIN11']}}
                </h5>
              </button>


              <!-- <button *ngIf="!sendOTPbutonHide && !otp_flag" class="btn sub-con-1 w-100 sub-color" (click)="loginToAll()"
              type="button" [ngClass]="{'disabled':!checkMobileNumber(mobile_number)}">
              <h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN10']}}</h5>
            </button> -->
              <!-- <button class="btn sub-con-1 w-100 sub-color" (click)="verifyLoginToAll()" type="submit"
              [ngClass]="{'disabled': !checkOTP(otp_no) || !otp_no}">
              <h5 class="p-0 m-0">{{auth.allLableShowObj[auth.language_cd+'LOGIN7']}}</h5>
            </button> -->
            </div>
            <!-- <div class="col-1"></div> -->
          </div>
          <!-- Optional error display -->
          <div *ngIf="otp_no?.length === 0 && otpTouched" class="error">
            <small>OTP is required.</small>
          </div>


          <button class="login-button w-100 p-2"
            style="background-color:#007AFF; color: white;border: none; border-radius: 5px;" [disabled]="!otp_no"
            (click)="verifyLoginToAll()">
            Log In
          </button>


          <button class="login-other-button w-100 p-2" (click)="anotherLoginOpen()">Login to Another</button>

        </div>
      </div>
      
      </div>
      </div>
    </div>
  </div>
  <div class="footer-sign-in1">
    <div class="footer-left">
      <strong>Lucknow Nagar Nigam</strong>
      <p>लखनऊ नगर निगम</p>
      <p>Trilok Nath Road, Lalbagh <br>
        Lucknow, Uttar Pradesh 226001</p>
    </div>
    <div class="footer-right">
      <p><strong>Contact Information</strong></p>
      <!-- <p>Phone: 0522-2622242</p> -->
      <!-- <p>Email: loremnagarnigamlucknow&#64;gmail.com</p> -->
      <p>Helpline: 9918000241</p>
    </div>
  </div>
</div>


   <!-- OTP Sent Success Modal -->
        <div *ngIf="showModal" class="modal-overlay">
          <div class="modal-content">
            <svg xmlns="http://www.w3.org/2000/svg" width="78" height="78" viewBox="0 0 78 78" fill="none">
              <path
                d="M39 68.25C45.7671 68.25 52.3249 65.9036 57.556 61.6106C62.7871 57.3175 66.3678 51.3435 67.688 44.7064C69.0082 38.0693 67.9862 31.1797 64.7962 25.2116C61.6062 19.2436 56.4455 14.5662 50.1935 11.9765C43.9415 9.38685 36.9849 9.0451 30.5092 11.0095C24.0334 12.9739 18.4391 17.1229 14.6795 22.7496C10.9199 28.3762 9.22755 35.1324 9.89085 41.867C10.5541 48.6015 13.532 54.8978 18.3171 59.6829"
                stroke="#2AA90B" stroke-width="5" stroke-linecap="round" />
              <path
                d="M52 32.5L37.152 50.3175C36.4965 51.1042 36.1687 51.4976 35.7281 51.5176C35.2875 51.5375 34.9255 51.1755 34.2014 50.4514L26 42.25"
                stroke="#2AA90B" stroke-width="5" stroke-linecap="round" />
            </svg>
            <h3>Success</h3>
            <p>OTP Sent Successfully</p>
            <button (click)="proceedToStep2()">OK</button>
          </div>
        </div>